import { Reducer } from "redux";
import { createReducer, ActionType } from "typesafe-actions";

import { IUserState } from "./types";
import * as UserActions from "./actions";
import { ILoginResponse } from "app/services/default";
import { createIAsyncState, IAsyncStateCreators } from "app/core/redux";

type UserAction = ActionType<typeof UserActions>;

const asyncCreator: IAsyncStateCreators = {
    login: createIAsyncState<ILoginResponse>({ token: "" })
};

const initialState: IUserState = {
    user: asyncCreator.login.initial()
};

const userReducer: Reducer<IUserState, UserAction> = createReducer<IUserState>(initialState)
    .handleAction(UserActions.getUsersAsync.request,
        (state: IUserState) => ({ ...state, login: asyncCreator.login.requesting() }))
    .handleAction(UserActions.getUsersAsync.success,
        (state: IUserState, action: any) => ({ ...state, login: asyncCreator.login.success(action.payload) }))
    .handleAction(UserActions.getUsersAsync.failure,
        (state: IUserState, action: any) => ({ ...state, login: asyncCreator.login.failure(action.error) }));

export default userReducer;
